require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-guettenbach.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-guettenbach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-guettenbach!./.cache/json/betreuungseinrichtungen-guessing-guettenbach.json
// module id = 888
// module chunks = 231608221292675